import React, { Component } from "react";
class HomePage extends Component {
  componentWillMount = () => {
    console.log("Mounting home");
    this.props.setAppDefault();
  };

  render() {
    // console.log(this.props.appState);

    return (
      <div
        className="flex-container"
        style={{
          display:
            this.props.appState.currentPage === "home" ? "block" : "none",
        }}
      >
        <div className="text-center">
          {/* <h1>Welcome</h1> */}
          <p>
            This page is related to the project on {" "}
            <a
              href="https://spire.ee.iisc.ac.in/spire/dysarthria.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              speech based neuro-degenerative diseases monitoring{" "}
            </a>
            at SPIRE Lab. Please contribute your voice to support this project.
          </p>

          <div className="text-left ml-5">
            <b>Instructions:</b>
            <ul>
              <li>
                If you have a social account (facebook or google), please login
                using the button at the top right corner for our ease of data
                maintenance.
              </li>
              <li>
                In case you don't have a social account, please ask another
                person close to you, a family member or a friend with a social
                account to login to our website. This will help us map you to
                the previous recordings you have generously provided.
              </li>
              <li>
                In case you can't at all abide by the above two options, don't
                worry, we have you covered. We respect your privacy, stay
                anonymous and contribute your voice.
              </li>
              <li>
                If you face <i> network error </i> message while trying to login, please reload the page again and ensure that you have a good internet connection.
              </li>
              <li style={{ color: 'red' }}>
                Please use either Google Chrome or Mozilla Firefox (non iOS device) for contributing your speech using this web application.
              </li>
            </ul>
          </div>

          <button
            className="btn btn-dark"
            onClick={() => this.props.setCurrentPage("terms")}
          >
            Start recording
          </button>
        </div>
      </div>
    );
  }
}

export default HomePage;
